module.exports = __webpack_public_path__ + "img/tablet.png?879acb11b9e30b49379136851fd884f0";